<div class="modal-header">
  @if (isNewOrganizationConstant) {
    <h4 class="modal-title h5" translate>New organization constant</h4>
  }
  @if (!isNewOrganizationConstant) {
    <h4 class="modal-title h5" translate>Edit organization constant</h4>
  }
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="constantModalForm" (ngSubmit)="onSave()">
  <div class="modal-body">
    <!--PORTAL SETTING-->
    <div class="form-row">
      <div class="col-12 col-lg-6">
        <div class="form-group mb-3 mb-lg-0">
          <label for="portalSetting">
            <span translate>Portal setting</span>
          </label>
          <ng-select [readonly]="!isNewOrganizationConstant"
            id="portalSetting"
            formControlName="portalSetting"
            [ngClass]="{ 'is-invalid': f.portalSetting.errors }"
            [items]="portalSettings" bindLabel="name">
          </ng-select>
          @if (f.portalSetting.errors) {
            <div class="invalid-feedback">
              @if (f.portalSetting.errors.required) {
                <span translate>The portal setting is required</span>
              }
            </div>
          }
        </div>
      </div>
      <!-- UNIT OF MEASURE -->
      <div class="col-6 col-lg-3">
        <div class="form-group">
          <label for="unit" translate>Unit</label>
          <input name="unit"
            formControlName="unit"
            id="unit"
            type="text"
            class="form-control">
          </div>
        </div>

        <!-- DECIMAL PLACES-->
        <div class="col-6 col-lg-3">
          <div class="form-group">
            <label for="decimalPlaces" translate>Decimal places</label>
            <input name="decimalPlaces"
              formControlName="decimalPlaces"
              id="decimalPlaces"
              type="number"
              [ngClass]="{ 'is-invalid': f.decimalPlaces.errors }"
              [min]="DECIMAL_PLACES_MIN"
              [max]="DECIMAL_PLACES_MAX"
              class="form-control">
              @if (f.decimalPlaces.errors) {
                <div class="invalid-feedback">
                  @if (f.decimalPlaces.errors.min) {
                    <span><span translate>Min value is</span> {{DECIMAL_PLACES_MIN}}</span>
                  }
                  @if (f.decimalPlaces.errors.max) {
                    <span><span translate>Max value is</span> {{DECIMAL_PLACES_MAX}}</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <form formArrayName="editValuesFormArray">
          <scitis-admin-organization-constant-values-editor
            [constant]="constant"
            [parentFormGroup]="constantModalForm">

          </scitis-admin-organization-constant-values-editor>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary"
          (click)="onCancel()">
          <span translate>Cancel</span>
        </button>
        <button type="button" class="btn btn-primary"
          [disabled]="constantModalForm.invalid"
          (click)="onSave()">
          <span translate>Save</span>
        </button>
      </div>
    </form>
